import React from "react";
import cx from "clsx";
import InputMask from "react-input-mask";
import moment from "moment";
import styles from "../../sass/components/GfeInputs.module.scss";
import { ProviderSingleDateCalendar } from "../../../../Components/Dashboard/ProviderDashboard/components/ProviderSingleDateCalendar";

const GfeInputs = ({
  dob,
  handleDob,
  hasDobError,
  size,
  showLabels,
  calendarClassName,
  containerClassName,
}) => {
  return (
    <div className={cx(styles.container, containerClassName)}>
      {dob && (
        <div className={styles.inputContainer}>
          {showLabels && <span className={styles.label}>Date of Birth</span>}
          <div
            className={cx(
              styles.gfeDobInput,
              size === "small" && styles.smallSize,
              { [styles.error]: hasDobError },
            )}
          >
            <InputMask
              name="dob"
              value={
                moment(dob).isValid() ? moment(dob).format("MM/DD/YYYY") : dob
              }
              mask="99/99/9999"
              placeholder="Date of Birth"
              onChange={(e) => {
                handleDob(e.target.value);
              }}
            />
            <ProviderSingleDateCalendar
              className={cx(styles.dobCalendar)}
              calendarClassName={calendarClassName}
              selectedDate={
                dob
                  ? moment(dob).format("YYYY-MM-DD")
                  : moment().format("YYYY-MM-DD")
              }
              onChange={(value) =>
                handleDob(moment(value).format("MM/DD/YYYY"))
              }
              hideValue
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default GfeInputs;
